__turbopack_context__.v({
  "checkboxLabel": "ProductComparisonCheckbox-module-scss-module__cn-_wa__checkboxLabel",
});
